const postActionsStore = {
  toastr: 'Acción agregada',
  toastr1: 'Acción fue agregado con éxito'
};

export default postActionsStore;
